import { render, staticRenderFns } from "./SendBulk.vue?vue&type=template&id=b1a3a12e&scoped=true&"
import script from "./SendBulk.vue?vue&type=script&lang=js&"
export * from "./SendBulk.vue?vue&type=script&lang=js&"
import style0 from "./SendBulk.vue?vue&type=style&index=0&id=b1a3a12e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a3a12e",
  null
  
)

component.options.__file = "SendBulk.vue"
export default component.exports